import React from 'react'
import { Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'
import './dashboard.css';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import CommentIcon from '@material-ui/icons/Comment';






const DashBoard = () => {


  return (
    <div className='container'>
      <div>
        <Typography variant='h4' >Choose Application</Typography>
      </div>

      <div className='apps-list'>
        <section>
          <PeopleAltIcon className='icon' />  <Link to='/membership' className='link' >Membership </Link>
        </section>
        <section>
          <CommentIcon className='icon' /> <Link to='/feeds' className='link' > Feeds & Posters </Link>
        </section>
      </div>


    </div>
  )
}

export default DashBoard;